import ICountryVm from "../models/shared/ICountryVm";
import * as ICountryVmInstance from "../models/shared/ICountryVm";

export default class CountryHelper {
  public static getCountriesOptionsForAddress(addEmptyOption?: boolean): [{ key: string; value: string }] {
    const countriesOptions: [{ key: string; value: string }] = (window as any).countries
      .filter((x: ICountryVm) => x.isOnlyUsedForBirthplace === false)
      .map((x: ICountryVm) => {
        return { key: x.id, value: x.countryName };
      });

    if (addEmptyOption) {
      countriesOptions.unshift({ key: "", value: "" });
    }

    return countriesOptions;
  }

  public static getCountriesOptionsForBirthplaceOrNationality(addEmptyOption?: boolean): [{ key: string; value: string }] {
    const countriesOptions: [{ key: string; value: string }] = (window as any).countries.map((x: ICountryVm) => {
      return { key: x.id, value: x.countryName };
    });

    if (addEmptyOption) {
      countriesOptions.unshift({ key: "", value: "" });
    }

    return countriesOptions;
  }

  /**
   * Returns country based on id
   * @param id
   * @param returnEmptyIfNull Return an empty object instead of undefined
   */
  public static getCountry(id: string, returnEmptyIfNull: boolean): ICountryVm {
    const country = ((window as any).countries as ICountryVm[]).filter((x) => x.id === id)[0];

    if (returnEmptyIfNull && country === undefined) {
      return ICountryVmInstance.empty();
    } else {
      return country;
    }
  }

  /**
   * Returns country based on countryCode
   * @param countryCode
   * @param returnEmptyIfNull Return an empty object instead of undefined
   */
  public static getCountryByCountryCode(countryCode: string, returnEmptyIfNull: boolean): ICountryVm {
    let country: ICountryVm;
    // If countryCode is null or undefined, we dont try to find it in the list
    if (countryCode !== undefined && countryCode !== null) {
      country = ((window as any).countries as ICountryVm[]).filter((x) => x.countryCodeAlpha2.toLocaleLowerCase() === countryCode.toLocaleLowerCase())[0];
    }

    if (returnEmptyIfNull && (country === undefined || country === null)) {
      return ICountryVmInstance.empty();
    } else {
      return country;
    }
  }

  /**
   * Returns country based on countryName
   * @param countryName
   * @param returnEmptyIfNull Return an empty object instead of undefined
   */
  public static getCountryByCountryName(countryName: string, returnEmptyIfNull: boolean): ICountryVm {
    const country = ((window as any).countries as ICountryVm[]).filter((x) => x.countryName.toLocaleLowerCase() === countryName.toLocaleLowerCase())[0];

    if (returnEmptyIfNull && country === undefined) {
      return ICountryVmInstance.empty();
    } else {
      return country;
    }
  }
}
